var banner_slide = new Swiper('.banner_slide', {
    slidesPerView: 1.2,
    spaceBetween: 10,
    mousewheel: true,
    breakpoints: { //반응형 조건 속성

        768: {
            slidesPerView: 3,
            direction: 'vertical',
            touchRatio: 0
        },
        1024: {
            slidesPerView: 'auto',
            direction: 'vertical',
            slideToClickedSlide: false,
            touchRatio: 0
        },
    }
});
$(function () {
    //이벤트 팝업 슬라이드
    $('.banner_notice').click(function () {
        console.log('modal open');
        $('.banner_slide_wrap').addClass('modal-open');
    });

    $('.open_pop').click(function () {
        $('.banner_slide_wrap').removeClass('modal-open');
    });

    var bannerSlideWrap = $('.banner_slide_wrap');
    var scrollThreshold = 42;
    $(window).scroll(function () {
        if ($(window).scrollTop() > scrollThreshold) {
            bannerSlideWrap.addClass('active');
        } else {
            bannerSlideWrap.removeClass('active');
        }
    });
});